<template>
  <v-card>
    <v-flex xs12 v-if="messages">
      <message :messages="messages"></message>
    </v-flex>
    <v-card-title>
      <v-flex xs6>
        <div class="headline">Risk</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.riskNo }}</td>
        <td class="text-xs-left">{{ props.item.defBusCls }} - {{ props.item.defBusClsDesc }}</td>
        <td class="text-xs-left">{{ props.item.defTariff }} - {{ props.item.defTariffDesc }}</td>
        <td class="text-xs-left">{{ formatBoolean(props.item.allowClmBefCvr) }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew">New Risk<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Risk?
      <div class="title">{{deleteRisk}}</div>
    </confirm>
  </v-card>
</template>
<script>
import * as TableConst from '@/mixins/table'
import { mapGetters, mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Risk No', value: 'riskNo' },
        { text: 'Default Business Class', value: 'defBusCls' },
        { text: 'Default Tariff', value: 'defTariff' },
        { text: 'Allow Claim Before Coverage', value: 'allowClmBefCvr' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortBy: 'riskNo'
      },
      deleteRisk: '',
      promptRemove: false,
      menu: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    pkgPlanMenu() {
      return this.$store.state.parameters.scheme.pkgPlanMenu
    }
  },
  watch: {
    'fetchRisk': function(value) {
      if (value !== false) {
        if (this.ids.planNo !== 'new') {
          this.fetchData(this.ids.planNo)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'pkgPlanMenuInit'
    ]),
    async fetchData(planNo) {
      const expand = {
        scheme: this.ids.scheme,
        planNo: this.ids.planNo
      }
      if (this.pkgPlanMenu.init !== 1) {
        await this.pkgPlanMenuInit(expand)
      }
      const apiURI = this.pkgPlanMenu.menu.pkgRisks
      if (apiURI) {
        const expand = {
          scheme: this.ids.scheme,
          planNo: planNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((pkgRisk) => {
              const convertPkgRisk = {
                scheme: pkgRisk.scheme,
                planNo: pkgRisk.planNo,
                riskNo: pkgRisk.riskNo,
                defBusCls: pkgRisk.defBusCls,
                defBusClsDesc: pkgRisk.defBusClsDesc,
                defTariff: pkgRisk.defTariff,
                defTariffDesc: pkgRisk.defTariffDesc,
                allowClmBefCvr: pkgRisk.allowClmBefCvr
              }
              this.items.push(convertPkgRisk)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid Api URL - Package Risk List')
        this.items = []
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedRisk = data
        this.deleteRisk = data.riskNo
      }
    },
    async doRemove() {
      const apiURI = this.pkgPlanMenu.menu.pkgRiskDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedRisk.scheme,
          planNo: this.ids.planNo,
          riskNo: this.selectedRisk.riskNo,
          defBusCls: this.selectedRisk.defBusCls,
          defTariff: this.selectedRisk.defTariff,
          allowClmBefCvr: this.selectedRisk.allowClmBefCvr
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.planNo)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Risk')
      }
    }
  },
  props: {
    fetchRisk: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          planNo: null,
          riskNo: null
        }
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
